module.exports = __webpack_public_path__ + "img/aParty_111523_J.1c1e0a5d.jpg";